import './index.styl';
import template from './index.jst';
import { User } from '../../../models';

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import { sendDataLayer } from '../../../../../core/utils';


import _ from 'lodash';

const tippingChannel = Radio.channel('tipping');

export default class UserInfoRow extends View {
	get template() {
		return template;
	}

	className() {
		return 'user-info-inner';
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			select: '#rounds-select',
			share: '.js-sharing',
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'change @ui.select': 'broadcastSelectedRound',
			'click @ui.share': 'shareTips'
		};
	}

	initialize() {
		const {
			rounds,
			wm_matches,
			current_round: selected_round
		} = this.options;
		
		this.model.set({
			avatar_url: User.get('avatar_url'),
			tipping_team_name: User.get('tipping_team_name'),
			selected_tips_count: 0,
			total_tips_count: 0,
			rounds: rounds ? rounds.toJSON() : [],
			wm_matches: wm_matches ? wm_matches.toJSON() : [],
			selected_round: selected_round ? selected_round.get('id') : 1,
			round_points: 0,
			total_points: 0,
			overall_rank: 0,
			total_ranked_users: 0,
			total_margin: 0,
			total_tips_possible: 0,
			round_tips_possible: 0,
			show_rank: true
		}, { silent: true });

		if(window.location.pathname.includes('streak')){
			this.model.set({
				show_rank: false
			})
		}
		

		
		this.share = this.getOption('share');
		this.user_snapshot = this.getOption('user_snapshot');
		this.listenTo(this.model, 'change', this.render);
		this.listenTo(tippingChannel, 'tips:count', this.onReceiveNewData);
		this.listenTo(tippingChannel, 'show:controls', this.onShowControls);
		this.listenTo(tippingChannel, 'change:round', this.updateModel);
		this.model.getData();

	}

	onReceiveNewData(args) {
		this.model.set(args);
		if(args['selected_round'] && args['rounds']){
			const selected_round_id = args['selected_round'];
			tippingChannel.trigger('change:round', { round_id: selected_round_id });
			const maxRound = args['selected_round'] - 1;
			const rounds = args['rounds'];
			const round = rounds.find(round => {
				return round.id === args['selected_round']
			});
			const matchesNum = round.matches.length;
			const roundsToUse = args['rounds'].slice(0, maxRound)
			const matchesCompleted = roundsToUse.reduce((matchCompleted, thisRound) => {
				if(thisRound.matches.length > 0){
					const matchesComplete = thisRound.matches.filter(match => 
						match.status === 'complete').length;
					return matchCompleted += matchesComplete;
				}
				return matchCompleted
			}, 0)
			this.model.set({ 
				round_tips_possible: matchesNum, 
				total_tips_possible: matchesCompleted 
			})
		}
		return this;
	}

	onShowControls({ rounds, current_round }) {
		return this.onReceiveNewData({
			rounds: rounds.toJSON(),
			selected_round: current_round.get('id'),
			current_round: current_round.get('id')
		});
	}

	broadcastSelectedRound({ target }) {
		this.sendGoogleTag();
		const selected_round = parseInt(target.value, 10);

		this.model.set({ selected_round });

		tippingChannel.trigger('change:round', { round_id: selected_round });
		this.trigger(tippingChannel, 'change:round', { round_id: selected_round });
	}

	shareTips(element) {
		let data = {
			sc: $(element.currentTarget).data('type')
		};

		this.share.share(data);
	}

	async updateModel( round_obj ) {
		let round = _.result( round_obj, 'round_id' );

		await this.model.getData({ data: { round } });

		this.render();
	}

	sendGoogleTag() {
		sendDataLayer({
			'event': 'virtual_page_view',
			'page_url': 'my-tips',
			'page_name': 'My Tips'
		});

		return this;
	}
}